import { render } from "./PpcBAAcosRoasCell.vue?vue&type=template&id=b77673f6&scoped=true"
import script from "./PpcBAAcosRoasCell.vue?vue&type=script&lang=js"
export * from "./PpcBAAcosRoasCell.vue?vue&type=script&lang=js"

import "./PpcBAAcosRoasCell.vue?vue&type=style&index=0&id=b77673f6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b77673f6"]])

export default __exports__